'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $p_sc_StringParsers$__step$1__I__T__I__I__Z__s_Option($thiz, len$2, from$2, i, agg, isPositive) {
  var agg$tailLocal2 = agg;
  var i$tailLocal2 = i;
  while (true) {
    if ((i$tailLocal2 === len$2)) {
      return ((!isPositive) ? new $j_java$002elang$002e$002dObject.$c_s_Some(agg$tailLocal2) : ((agg$tailLocal2 === (-2147483648)) ? $j_java$002elang$002e$002dObject.$m_s_None$() : new $j_java$002elang$002e$002dObject.$c_s_Some(((-agg$tailLocal2) | 0))));
    } else if ((agg$tailLocal2 < (-214748364))) {
      return $j_java$002elang$002e$002dObject.$m_s_None$();
    } else {
      var digit = $j_java$002elang$002e$002dObject.$m_jl_Character$().Bk(from$2.charCodeAt(i$tailLocal2), 10);
      if (((digit === (-1)) || ((((-214748364) ^ agg$tailLocal2) | (9 ^ digit)) === 0))) {
        return $j_java$002elang$002e$002dObject.$m_s_None$();
      } else {
        var i$tailLocal2$tmp1 = ((1 + i$tailLocal2) | 0);
        var agg$tailLocal2$tmp1 = ((Math.imul(10, agg$tailLocal2) - digit) | 0);
        i$tailLocal2 = i$tailLocal2$tmp1;
        agg$tailLocal2 = agg$tailLocal2$tmp1;
      }
    }
  }
}
export { $p_sc_StringParsers$__step$1__I__T__I__I__Z__s_Option as $p_sc_StringParsers$__step$1__I__T__I__I__Z__s_Option };
function $p_sc_StringParsers$__isHexDigit$1__C__Z($thiz, ch) {
  return ((((((ch - 48) | 0) >>> 0) <= 9) || ((((ch - 97) | 0) >>> 0) <= 5)) || ((((ch - 65) | 0) >>> 0) <= 5));
}
export { $p_sc_StringParsers$__isHexDigit$1__C__Z as $p_sc_StringParsers$__isHexDigit$1__C__Z };
function $p_sc_StringParsers$__prefixOK$1__T__I__I__Z($thiz, format$6, startIndex, endIndex) {
  var len = ((endIndex - startIndex) | 0);
  if ((len > 0)) {
    if ((format$6.charCodeAt(startIndex) === 46)) {
      if ((len > 1)) {
        var start = ((1 + startIndex) | 0);
        var i$tailLocal4 = start;
        while (true) {
          if ((i$tailLocal4 >= endIndex)) {
            return true;
          } else {
            if ($p_sc_StringParsers$__isHexDigit$1__C__Z($thiz, format$6.charCodeAt(i$tailLocal4))) {
              i$tailLocal4 = ((1 + i$tailLocal4) | 0);
              continue;
            }
            return false;
          }
        }
      } else {
        return false;
      }
    } else {
      var noLeading;
      var i$tailLocal5 = startIndex;
      while (true) {
        if (((i$tailLocal5 < endIndex) && $p_sc_StringParsers$__isHexDigit$1__C__Z($thiz, format$6.charCodeAt(i$tailLocal5)))) {
          i$tailLocal5 = ((1 + i$tailLocal5) | 0);
          continue;
        }
        var noLeading = i$tailLocal5;
        break;
      }
      if ((noLeading >= endIndex)) {
        return true;
      } else if ((format$6.charCodeAt(noLeading) === 46)) {
        var start$1 = ((1 + noLeading) | 0);
        var i$tailLocal4$1 = start$1;
        while (true) {
          if ((i$tailLocal4$1 >= endIndex)) {
            return true;
          } else {
            if ($p_sc_StringParsers$__isHexDigit$1__C__Z($thiz, format$6.charCodeAt(i$tailLocal4$1))) {
              i$tailLocal4$1 = ((1 + i$tailLocal4$1) | 0);
              continue;
            }
            return false;
          }
        }
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
}
export { $p_sc_StringParsers$__prefixOK$1__T__I__I__Z as $p_sc_StringParsers$__prefixOK$1__T__I__I__Z };
function $p_sc_StringParsers$__postfixOK$1__T__I__I__Z($thiz, format$7, startIndex, endIndex) {
  if ((startIndex < endIndex)) {
    var $x_1;
    var i$tailLocal4 = startIndex;
    while (true) {
      if ((i$tailLocal4 >= endIndex)) {
        var $x_1 = true;
        break;
      } else {
        if (((((format$7.charCodeAt(i$tailLocal4) - 48) | 0) >>> 0) <= 9)) {
          i$tailLocal4 = ((1 + i$tailLocal4) | 0);
          continue;
        }
        var $x_1 = false;
        break;
      }
    }
    if ($x_1) {
      return true;
    } else {
      var startchar = format$7.charCodeAt(startIndex);
      if ((((startchar === 43) || (startchar === 45)) && (((endIndex - startIndex) | 0) > 1))) {
        var start = ((1 + startIndex) | 0);
        var i$tailLocal4$1 = start;
        while (true) {
          if ((i$tailLocal4$1 >= endIndex)) {
            return true;
          } else {
            if (((((format$7.charCodeAt(i$tailLocal4$1) - 48) | 0) >>> 0) <= 9)) {
              i$tailLocal4$1 = ((1 + i$tailLocal4$1) | 0);
              continue;
            }
            return false;
          }
        }
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
}
export { $p_sc_StringParsers$__postfixOK$1__T__I__I__Z as $p_sc_StringParsers$__postfixOK$1__T__I__I__Z };
function $p_sc_StringParsers$__isHexFloatLiteral$1__T__I__I__Z($thiz, format$5, startIndex, endIndex) {
  $j_java$002elang$002e$002dObject.$m_sc_StringOps$();
  _return: {
    var len = format$5.length;
    var i = startIndex;
    while ((i < len)) {
      var index = i;
      var x0 = format$5.charCodeAt(index);
      if (((x0 === 80) || (x0 === 112))) {
        var pIndex = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var pIndex = (-1);
  }
  return (((pIndex <= endIndex) && $p_sc_StringParsers$__prefixOK$1__T__I__I__Z($thiz, format$5, startIndex, pIndex)) && $p_sc_StringParsers$__postfixOK$1__T__I__I__Z($thiz, format$5, ((1 + pIndex) | 0), endIndex));
}
export { $p_sc_StringParsers$__isHexFloatLiteral$1__T__I__I__Z as $p_sc_StringParsers$__isHexFloatLiteral$1__T__I__I__Z };
function $p_sc_StringParsers$__isExp$1__C__Z($thiz, c) {
  return ((c === 69) || (c === 101));
}
export { $p_sc_StringParsers$__isExp$1__C__Z as $p_sc_StringParsers$__isExp$1__C__Z };
function $p_sc_StringParsers$__expOK$1__T__I__I__Z($thiz, format$9, startIndex, endIndex) {
  if ((startIndex < endIndex)) {
    var startChar = format$9.charCodeAt(startIndex);
    if (((startChar === 43) || (startChar === 45))) {
      if ((endIndex > ((1 + startIndex) | 0))) {
        var from = ((1 + startIndex) | 0);
        var $x_1;
        var i$tailLocal5 = from;
        while (true) {
          if (((i$tailLocal5 < endIndex) && ((((format$9.charCodeAt(i$tailLocal5) - 48) | 0) >>> 0) <= 9))) {
            i$tailLocal5 = ((1 + i$tailLocal5) | 0);
            continue;
          }
          var $x_1 = i$tailLocal5;
          break;
        }
        return ($x_1 === endIndex);
      } else {
        return false;
      }
    } else {
      var $x_2;
      var i$tailLocal5$1 = startIndex;
      while (true) {
        if (((i$tailLocal5$1 < endIndex) && ((((format$9.charCodeAt(i$tailLocal5$1) - 48) | 0) >>> 0) <= 9))) {
          i$tailLocal5$1 = ((1 + i$tailLocal5$1) | 0);
          continue;
        }
        var $x_2 = i$tailLocal5$1;
        break;
      }
      return ($x_2 === endIndex);
    }
  } else {
    return false;
  }
}
export { $p_sc_StringParsers$__expOK$1__T__I__I__Z as $p_sc_StringParsers$__expOK$1__T__I__I__Z };
function $p_sc_StringParsers$__isDecFloatLiteral$1__T__I__I__Z($thiz, format$8, startIndex, endIndex) {
  var startChar = format$8.charCodeAt(startIndex);
  if ((startChar === 46)) {
    var from = ((1 + startIndex) | 0);
    var noSignificant;
    var i$tailLocal5 = from;
    while (true) {
      if (((i$tailLocal5 < endIndex) && ((((format$8.charCodeAt(i$tailLocal5) - 48) | 0) >>> 0) <= 9))) {
        i$tailLocal5 = ((1 + i$tailLocal5) | 0);
        continue;
      }
      var noSignificant = i$tailLocal5;
      break;
    }
    return ((noSignificant > ((1 + startIndex) | 0)) && ((noSignificant >= endIndex) || ($p_sc_StringParsers$__isExp$1__C__Z($thiz, format$8.charCodeAt(noSignificant)) && $p_sc_StringParsers$__expOK$1__T__I__I__Z($thiz, format$8, ((1 + noSignificant) | 0), endIndex))));
  } else if (((((startChar - 48) | 0) >>> 0) <= 9)) {
    var noInt;
    var i$tailLocal5$1 = startIndex;
    while (true) {
      if (((i$tailLocal5$1 < endIndex) && ((((format$8.charCodeAt(i$tailLocal5$1) - 48) | 0) >>> 0) <= 9))) {
        i$tailLocal5$1 = ((1 + i$tailLocal5$1) | 0);
        continue;
      }
      var noInt = i$tailLocal5$1;
      break;
    }
    if ((noInt === endIndex)) {
      return true;
    } else if ((format$8.charCodeAt(noInt) === 46)) {
      var from$1 = ((1 + noInt) | 0);
      var noSignificant$2;
      var i$tailLocal5$2 = from$1;
      while (true) {
        if (((i$tailLocal5$2 < endIndex) && ((((format$8.charCodeAt(i$tailLocal5$2) - 48) | 0) >>> 0) <= 9))) {
          i$tailLocal5$2 = ((1 + i$tailLocal5$2) | 0);
          continue;
        }
        var noSignificant$2 = i$tailLocal5$2;
        break;
      }
      return ((noSignificant$2 >= endIndex) || ($p_sc_StringParsers$__isExp$1__C__Z($thiz, format$8.charCodeAt(noSignificant$2)) && $p_sc_StringParsers$__expOK$1__T__I__I__Z($thiz, format$8, ((1 + noSignificant$2) | 0), endIndex)));
    } else {
      return ($p_sc_StringParsers$__isExp$1__C__Z($thiz, format$8.charCodeAt(noInt)) && $p_sc_StringParsers$__expOK$1__T__I__I__Z($thiz, format$8, ((1 + noInt) | 0), endIndex));
    }
  } else {
    return false;
  }
}
export { $p_sc_StringParsers$__isDecFloatLiteral$1__T__I__I__Z as $p_sc_StringParsers$__isDecFloatLiteral$1__T__I__I__Z };
/** @constructor */
function $c_sc_StringParsers$() {
}
export { $c_sc_StringParsers$ as $c_sc_StringParsers$ };
$p = $c_sc_StringParsers$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sc_StringParsers$;
/** @constructor */
function $h_sc_StringParsers$() {
}
export { $h_sc_StringParsers$ as $h_sc_StringParsers$ };
$h_sc_StringParsers$.prototype = $p;
$p.Ch = (function(from) {
  var len = from.length;
  if ((len === 0)) {
    return $j_java$002elang$002e$002dObject.$m_s_None$();
  } else {
    var first = from.charCodeAt(0);
    var v = $j_java$002elang$002e$002dObject.$m_jl_Character$().Bk(first, 10);
    return ((len === 1) ? ((v > (-1)) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$()) : ((v > (-1)) ? $p_sc_StringParsers$__step$1__I__T__I__I__Z__s_Option(this, len, from, 1, ((-v) | 0), true) : ((first === 43) ? $p_sc_StringParsers$__step$1__I__T__I__I__Z__s_Option(this, len, from, 1, 0, true) : ((first === 45) ? $p_sc_StringParsers$__step$1__I__T__I__I__Z__s_Option(this, len, from, 1, 0, false) : $j_java$002elang$002e$002dObject.$m_s_None$()))));
  }
});
$p.Bd = (function(format) {
  $j_java$002elang$002e$002dObject.$m_sc_StringOps$();
  $j_java$002elang$002e$002dObject.$m_sc_StringOps$();
  var from = 0;
  _return: {
    var len = format.length;
    var i = from;
    while ((i < len)) {
      if ((format.charCodeAt(i) > 32)) {
        var unspacedStart = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var unspacedStart = (-1);
  }
  $j_java$002elang$002e$002dObject.$m_sc_StringOps$();
  $j_java$002elang$002e$002dObject.$m_sc_StringOps$();
  var end = 2147483647;
  _return$1: {
    var len$1 = format.length;
    var y = ((len$1 - 1) | 0);
    var i$1 = ((end < y) ? end : y);
    while ((i$1 >= 0)) {
      if ((format.charCodeAt(i$1) > 32)) {
        var $x_1 = i$1;
        break _return$1;
      }
      i$1 = ((i$1 - 1) | 0);
    }
    var $x_1 = (-1);
  }
  var unspacedEnd = ((1 + $x_1) | 0);
  if ((!(((unspacedStart === (-1)) || (unspacedStart >= unspacedEnd)) || (unspacedEnd <= 0)))) {
    var startchar = format.charCodeAt(unspacedStart);
    var unsigned = (((startchar === 43) || (startchar === 45)) ? ((1 + unspacedStart) | 0) : unspacedStart);
    if ((unsigned < unspacedEnd)) {
      if ((format.charCodeAt(unsigned) === 78)) {
        return (format.substring(unsigned, unspacedEnd) === "NaN");
      } else if ((format.charCodeAt(unsigned) === 73)) {
        return (format.substring(unsigned, unspacedEnd) === "Infinity");
      } else {
        var index$2 = ((unspacedEnd - 1) | 0);
        var endchar = format.charCodeAt(index$2);
        var desuffixed = (((((endchar === 70) || (endchar === 102)) || (endchar === 100)) || (endchar === 68)) ? ((unspacedEnd - 1) | 0) : unspacedEnd);
        var len$2 = ((desuffixed - unsigned) | 0);
        return ((len$2 > 0) && (((len$2 >= 2) && ((format.charCodeAt(((1 + unsigned) | 0)) === 120) || (format.charCodeAt(((1 + unsigned) | 0)) === 88))) ? ((format.charCodeAt(unsigned) === 48) && $p_sc_StringParsers$__isHexFloatLiteral$1__T__I__I__Z(this, format, ((2 + unsigned) | 0), desuffixed)) : $p_sc_StringParsers$__isDecFloatLiteral$1__T__I__I__Z(this, format, unsigned, desuffixed)));
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
var $d_sc_StringParsers$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sc_StringParsers$, "scala.collection.StringParsers$", ({
  sB: 1
}));
export { $d_sc_StringParsers$ as $d_sc_StringParsers$ };
var $n_sc_StringParsers$;
function $m_sc_StringParsers$() {
  if ((!$n_sc_StringParsers$)) {
    $n_sc_StringParsers$ = new $c_sc_StringParsers$();
  }
  return $n_sc_StringParsers$;
}
export { $m_sc_StringParsers$ as $m_sc_StringParsers$ };
